import { createContext, useContext, useEffect, useState } from "react";
const GlobalContext = createContext();
export const useGlobalContext = () => useContext(GlobalContext);

export const API_URL = process.env.REACT_APP_API_URL;
export const RUN_DINAR_URL = process.env.REACT_APP_RUN_DINAR_URL;
export const RUN_B2B_URL = process.env.REACT_APP_RUN_B2B_URL;

export const getHeaders = () => {
  const headerText = new Headers();
  headerText.append("Content-Type", "application/json;charset=UTF-8");
  return headerText;
};

const AppContext = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const [isRecuperar, setIsRecuperar] = useState(false);

  const [usuario, setUsuario] = useState();

  const headerText = getHeaders();

  const [baseUrl, setBaseUrl] = useState(API_URL);

  const resolveInitialBrand = () => {
    const empresaActiva = Number(sessionStorage.getItem("empresaActiva"));
    if (empresaActiva === 5) return "dinar";
    if (empresaActiva === 6) return "sack";

    const configuredBrand = String(process.env.REACT_APP_BRAND || "").toLowerCase();
    if (["dinar", "sack"].includes(configuredBrand)) return configuredBrand;

    return String(API_URL || "").toLowerCase().includes("sack")
      ? "sack"
      : "dinar";
  };

  const [brand, setBrand] = useState(resolveInitialBrand);
  const isDinar = brand === "dinar";
  const isSack = brand === "sack";

  // backgroundColor: "#007ad9"
  const [styleProperties, setStyleProperties] = useState({
    logo: isDinar
      ? "assets/layout/images/logo_dinar.jpg"
      : "assets/layout/images/logo_sack.jpg",
    title: "Planificador",
    backgroundColor: "lightblue",
    button: {
      backgroundColor: "#20ba84",
      foreColor: "#fff",
      border: "1px solid #007ad9",
    },
  });

  useEffect(() => {
    setStyleProperties((current) => ({
      ...current,
      logo: isDinar
        ? "assets/layout/images/logo_dinar.jpg"
        : "assets/layout/images/logo_sack.jpg",
    }));
  }, [isDinar]);

  return (
    <GlobalContext.Provider
      value={{
        baseUrl,
        setBaseUrl,
        brand,
        setBrand,
        isDinar,
        isSack,
        styleProperties,
        setStyleProperties,
        isLoggedIn,
        setIsLoggedIn,
        usuario,
        setUsuario,
        isRecuperar,
        setIsRecuperar,
        headerText,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};

export default AppContext;
